import React, { useEffect, useRef, useState } from "react";
import { Box, Stack } from '@mui/material';
import { query, collection, orderBy, onSnapshot, limit } from "firebase/firestore";
import { db } from "../../firebase";
import Message from "./message";
import SendMessage from "./sendMessage";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";

const ChatBox = () => {
    const [messages, setMessages] = useState([]);
    const scrollRef = useRef();

    useEffect(() => {
        const q = query(
            collection(db, "messages"),
            orderBy("createdAt", "desc"),
            limit(50)
        );

        const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
            const fetchedMessages = [];
            QuerySnapshot.forEach((doc) => {
                fetchedMessages.unshift({ ...doc.data(), id: doc.id }); // unshift to maintain order
            });
            setMessages(fetchedMessages);
        });

        return () => unsubscribe;
    }, []);

    // Auto-scroll to the bottom on new messages
    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages]);

    return (
        <>
            <FlexBetween m="1.5rem 2.5rem">
                <Header title="CHAT" subtitle="" />
            </FlexBetween>
            <Box
                m= {{xs: "0rem 0rem", md:"0rem 2.5rem", lg:"0rem 2.5rem"}}
                sx={{
                width: { xs: '100%', sm: '60vw', md: '65vw', lg: '65vw' },
                padding: 2,
                height: 'auto',
                overflowY: 'auto',
            }}>
                <Stack spacing={2}>
                    {messages?.map((message) => (
                        <Message key={message.id} message={message} createdAt={message.createdAt}/>
                    ))}
                    <span ref={scrollRef}></span>
                </Stack>
                <SendMessage scroll={scrollRef} />
            </Box>
        </>
    );
};

export default ChatBox;
